import React from 'react';

function formatTime(seconds) {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
}

const Timer = ({ timeLeft }) => (
    <div className="timer">
        <h1>{formatTime(timeLeft)}</h1>
    </div>
);

export default Timer;